import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { formatDateTime } from '../../js/utils'

const propertiesToExclude = [ 'IsCompositeKey', 'PrimaryKeyFields', 'PKEntityFieldName', 
  'PKSequenceName', 'PKDatabaseField', 'PK', 'ModifiedDate', 'ModifiedByUser', 'CreatedDate', 'CreatedByUser' ]

const ExpandedRowTemplate = rowData => {
  let auditData = JSON.parse(rowData['AuditData'])
  let auditDataProperties = Object.getOwnPropertyNames(auditData)
    .filter(propertyName => !propertiesToExclude.some(excludeProperty => excludeProperty === propertyName))
  return (
    <div className={"p-grid"}>
      {auditDataProperties.map(propertyName => {
        let propertyValue = auditData[propertyName]
        return (
          <React.Fragment key={propertyName}>
            <div className={"p-col-6"}>
              {propertyName}
            </div>
            <div className={"p-col-6"}>
              {propertyValue}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

const AuditDateTemplate = rowData => {
  return <span>{formatDateTime(rowData['AuditDate'])}</span>;
}

const AuditLogTable = ({ auditLogEntries, expandedRows, rowToggled }) => {
  return (
    <DataTable value={auditLogEntries} className={'audit-log-table'} expandedRows={expandedRows} paginator={true}
      rows={10} rowsPerPageOptions={[10,20,50]}
      onRowToggle={rowToggled} rowExpansionTemplate={ExpandedRowTemplate}>
      <Column expander={true} style={{ width: '2em' }} />
      <Column field="AuditDate" header="Date/time" body={AuditDateTemplate} />
      <Column field="AuditUsername" header="Username" />
      <Column field="TypeName" header="Type" />
      <Column field="Action" header="Action" />
      <Column field="PrimaryId" header="Identifier" />
      <Column field="Lobbyist" header="Lobbyist" />
    </DataTable>
  )
}

export default AuditLogTable



// WEBPACK FOOTER //
// ./src/components/audit-log/audit-log-table.js